module.exports = __webpack_public_path__ + "media/images/icons/ihra_linkedin_share-a1002674008f52bc0627bdbf3c440e02.svg";